module.exports = __webpack_public_path__ + "img/Photo45.2b9a571a.jpg";